import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { markProfilingEnd, markProfilingStart, withProfiling } from '../../self-measurements';
import EntriesTimeline from './entries-timeline';
import _getElementName from './get-element-name';
import VCCalculator_FY25_03 from './metric-calculator/fy25_03';
import ViewportObserver from './viewport-observer';
import WindowEventObserver from './window-event-observer';
var DEFAULT_SELECTOR_CONFIG = {
  id: false,
  testId: true,
  role: false,
  className: false,
  dataVC: true
};
var VCObserverNew = /*#__PURE__*/function () {
  function VCObserverNew(config) {
    var _config$selectorConfi,
      _this = this;
    _classCallCheck(this, VCObserverNew);
    _defineProperty(this, "viewportObserver", null);
    _defineProperty(this, "windowEventObserver", null);
    var operationTimer = markProfilingStart('VCObserverNew constructor');
    this.entriesTimeline = new EntriesTimeline();
    this.selectorConfig = (_config$selectorConfi = config.selectorConfig) !== null && _config$selectorConfi !== void 0 ? _config$selectorConfi : DEFAULT_SELECTOR_CONFIG;
    this.viewportObserver = new ViewportObserver({
      onChange: function onChange(onChangeArg) {
        var time = onChangeArg.time,
          type = onChangeArg.type,
          elementRef = onChangeArg.elementRef,
          visible = onChangeArg.visible,
          rect = onChangeArg.rect,
          previousRect = onChangeArg.previousRect,
          mutationData = onChangeArg.mutationData;
        var elementName = 'unknown';
        var element = elementRef.deref();
        if (element) {
          elementName = _this.getElementName(element);
        }
        _this.entriesTimeline.push({
          time: time,
          type: type,
          data: {
            elementName: elementName,
            rect: rect,
            previousRect: previousRect,
            visible: visible,
            attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName
          }
        });
      }
    });
    this.windowEventObserver = new WindowEventObserver({
      onEvent: function onEvent(_ref) {
        var time = _ref.time,
          type = _ref.type;
        _this.entriesTimeline.push({
          time: time,
          type: 'window:event',
          data: {
            eventType: type
          }
        });
      }
    });
    this.start = withProfiling(this.start.bind(this), ['vc']);
    this.stop = withProfiling(this.stop.bind(this), ['vc']);
    this.getVCResult = withProfiling(this.getVCResult.bind(this), ['vc']);
    this.getElementName = withProfiling(this.getElementName.bind(this), ['vc']);
    markProfilingEnd(operationTimer, {
      tags: ['vc']
    });
  }
  return _createClass(VCObserverNew, [{
    key: "start",
    value: function start(_ref2) {
      var _this$viewportObserve, _this$windowEventObse;
      var startTime = _ref2.startTime;
      (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
      (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
      this.entriesTimeline.clear();
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$viewportObserve2, _this$windowEventObse2;
      (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
      (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();
    }
  }, {
    key: "getVCResult",
    value: function () {
      var _getVCResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(param) {
        var start, stop, results, calculator_fy25_03, orderedEntries, fy25_03;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              start = param.start, stop = param.stop;
              results = [];
              calculator_fy25_03 = new VCCalculator_FY25_03();
              orderedEntries = this.entriesTimeline.getOrderedEntries({
                start: start,
                stop: stop
              });
              _context.next = 6;
              return calculator_fy25_03.calculate({
                orderedEntries: orderedEntries,
                startTime: start,
                stopTime: stop
              });
            case 6:
              fy25_03 = _context.sent;
              if (fy25_03) {
                results.push(fy25_03);
              }
              return _context.abrupt("return", results);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getVCResult(_x) {
        return _getVCResult.apply(this, arguments);
      }
      return getVCResult;
    }()
  }, {
    key: "getElementName",
    value: function getElementName(element) {
      return _getElementName(this.selectorConfig, element);
    }
  }]);
}();
export { VCObserverNew as default };